<span class="badge badge-config-pedido-tipo-venda badge-config-pedido-tipo-venda-outro"
    [title]="isAbreviacao ? tipo.nome : ''">
    {{isAbreviacao ? tipo.abreviacao : tipo.nome}}
</span>